export const T13 = {
    "columns": 12,
    "rows": 1.5,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Comparative Monthly Sales",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Group',
                        "columnName": 'ItemGroupCode',
                        "width": '160px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Jan',
                        "columnName": 'Jan',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Feb',
                        "columnName": 'Feb',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Mar',
                        "columnName": 'Mar',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Apr',
                        "columnName": 'Apr',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'May',
                        "columnName": 'May',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Jun',
                        "columnName": 'Jun',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Jul',
                        "columnName": 'Jul',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Aug',
                        "columnName": 'Aug',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Sep',
                        "columnName": 'Sep',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Oct',
                        "columnName": 'Oct',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Nov',
                        "columnName": 'Nov',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Dec',
                        "columnName": 'Dec',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Total Sales',
                        "columnName": 'TotalSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    }
                ],
                "title": 'DistributorName',
                "endpoint": "T13",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "AgentCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "ItemGroupCode",
                        "visuals": [
                            {
                                "title": "PESO",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PESO",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Product Group',
                                                            "columnName": 'ItemGroupCode',
                                                            "width": '160px',
                                                            "align": "left",
                                                            "sortable": true,
                                                            "sum": false
                                                        },
                                                        {
                                                            "name": 'Jan',
                                                            "columnName": 'Jan',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Feb',
                                                            "columnName": 'Feb',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Mar',
                                                            "columnName": 'Mar',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Apr',
                                                            "columnName": 'Apr',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'May',
                                                            "columnName": 'May',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Jun',
                                                            "columnName": 'Jun',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Jul',
                                                            "columnName": 'Jul',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Aug',
                                                            "columnName": 'Aug',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Sep',
                                                            "columnName": 'Sep',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Oct',
                                                            "columnName": 'Oct',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Nov',
                                                            "columnName": 'Nov',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Dec',
                                                            "columnName": 'Dec',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        },
                                                        {
                                                            "name": 'Total Sales',
                                                            "columnName": 'TotalSales',
                                                            "width": '125px',
                                                            "align": "right",
                                                            "sortable": true,
                                                            "sum": true
                                                        }
                                                    ],
                                                    "title": 'ItemGroupCode',
                                                    "endpoint": "T13.1",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "ItemGroupCode", "value": "" },
                                                        { "key": "AgentCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "ItemGroupCode",
                                                            "visuals": [
                                                                {
                                                                    "title": "Product",
                                                                    "visual": [
                                                                        {
                                                                            "columns": 12,
                                                                            "rows": 2,
                                                                            "visual": {
                                                                                "id": 1,
                                                                                "type": "advancedTable",
                                                                                "colorTheme": "colorTheme1",
                                                                                "title": "Product",
                                                                                "binding": {
                                                                                    "data": {
                                                                                        "columns": [
                                                                                            {
                                                                                                "name": 'Product Name',
                                                                                                "columnName": 'ItemName',
                                                                                                "width": '400px',
                                                                                                "align": "left",
                                                                                                "sortable": true,
                                                                                                "sum": false
                                                                                            },
                                                                                            {
                                                                                                "name": 'Jan',
                                                                                                "columnName": 'Jan',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Feb',
                                                                                                "columnName": 'Feb',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Mar',
                                                                                                "columnName": 'Mar',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Apr',
                                                                                                "columnName": 'Apr',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'May',
                                                                                                "columnName": 'May',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Jun',
                                                                                                "columnName": 'Jun',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Jul',
                                                                                                "columnName": 'Jul',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Aug',
                                                                                                "columnName": 'Aug',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Sep',
                                                                                                "columnName": 'Sep',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Oct',
                                                                                                "columnName": 'Oct',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Nov',
                                                                                                "columnName": 'Nov',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Dec',
                                                                                                "columnName": 'Dec',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            },
                                                                                            {
                                                                                                "name": 'Total Sales',
                                                                                                "columnName": 'TotalSales',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                                "sum": true
                                                                                            }
                                                                                        ],
                                                                                        "title": 'ItemName',
                                                                                        "endpoint": "T13.5",
                                                                                        "parameters": [
                                                                                            { "key": "FromMonth", "value": "2024" },
                                                                                            { "key": "FromYear", "value": "1" },
                                                                                            { "key": "ToMonth", "value": "2024" },
                                                                                            { "key": "ToYear", "value": "1" },
                                                                                            { "key": "ItemGroupCode", "value": "" },
                                                                                            { "key": "AgentCode", "value": "" },
                                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                                        ]
                                                                                    },
                                                                                    "context": {
                                                                                        "point": {
                                                                                            "onClick": {

                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                "title": "UNIT",
                                "visual": [
                                    {
                                        "columns": 12,
                                        "rows": 2,
                                        "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "UNIT",
                                            "binding": {
                                                "data": {
                                                    "columns": [
                                                        {
                                                            "name": 'Product Group',
                                                            "columnName": 'ItemGroupCode',
                                                            "width": '150px',
                                                            "align": "left",
                                                            "sortable": true,
                                                        }
                                                    ],
                                                    "title": 'ItemGroupCode',
                                                    "endpoint": "T13.2",
                                                    "parameters": [
                                                        { "key": "FromMonth", "value": "2024" },
                                                        { "key": "FromYear", "value": "1" },
                                                        { "key": "ToMonth", "value": "2024" },
                                                        { "key": "ToYear", "value": "1" },
                                                        { "key": "ItemGroupCode", "value": "" },
                                                        { "key": "AgentCode", "value": "" },
                                                        { "key": "ConfigTypeCode", "value": "" }
                                                    ]
                                                },
                                                "context": {
                                                    "point": {
                                                        "onClick": {
                                                            "selectedValueColumn": "ItemGroupCode",
                                                            "visuals": [
                                                                {
                                                                    "title": "Product",
                                                                    "visual": [
                                                                        {
                                                                            "columns": 12,
                                                                            "rows": 2,
                                                                            "visual": {
                                                                                "id": 1,
                                                                                "type": "advancedTable",
                                                                                "colorTheme": "colorTheme1",
                                                                                "title": "Product",
                                                                                "binding": {
                                                                                    "data": {
                                                                                        "columns": [
                                                                                            {
                                                                                                "name": 'Product Name',
                                                                                                "columnName": 'ItemName',
                                                                                                "width": '200px',
                                                                                                "align": "left",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Jan',
                                                                                                "columnName": 'Jan',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Feb',
                                                                                                "columnName": 'Feb',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Mar',
                                                                                                "columnName": 'Mar',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Apr',
                                                                                                "columnName": 'Apr',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'May',
                                                                                                "columnName": 'May',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Jun',
                                                                                                "columnName": 'Jun',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Jul',
                                                                                                "columnName": 'Jul',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Aug',
                                                                                                "columnName": 'Aug',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Sep',
                                                                                                "columnName": 'Sep',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Oct',
                                                                                                "columnName": 'Oct',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Nov',
                                                                                                "columnName": 'Nov',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Dec',
                                                                                                "columnName": 'Dec',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            },
                                                                                            {
                                                                                                "name": 'Total Sales',
                                                                                                "columnName": 'TotalSales',
                                                                                                "width": '125px',
                                                                                                "align": "right",
                                                                                                "sortable": true,
                                                                                            }
                                                                                        ],
                                                                                        "title": 'ItemName',
                                                                                        "endpoint": "T13.6",
                                                                                        "parameters": [
                                                                                            { "key": "FromMonth", "value": "2024" },
                                                                                            { "key": "FromYear", "value": "1" },
                                                                                            { "key": "ToMonth", "value": "2024" },
                                                                                            { "key": "ToYear", "value": "1" },
                                                                                            { "key": "ItemGroupCode", "value": "" },
                                                                                            { "key": "AgentCode", "value": "" },
                                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                                        ]
                                                                                    },
                                                                                    "context": {
                                                                                        "point": {
                                                                                            "onClick": {

                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        ]

                    }
                }
            }
        }
    }
}